<template>
  <div class="container">
    <section class="section contact">
      <div class="background">
        <video src="./../assets/images/earthloop.webm" muted autoplay loop ref="background-video"></video>
      </div>
      <div class="content">
        <p class="section-header" v-html="$translations.get('contact_header')">Our mark on the world</p>
        <p class="section-title" v-html="$translations.get('contact_title')">Contact us</p>
        <div class="section-text">
          <p v-html="$translations.get('contact_text')">
            Wagner - Hatfield works everywhere around the world, no matter where the challenge is we are here to help.
            Read
            more bellow to see what we have helped our clients with around the world
          </p>
          <br>
          <span v-html="$translations.get('contact_email_us')">E-mail us directly at: </span> <a class="blue"
                                                                                                 href="mailto:info@wagner-hatfield.com">info@wagner-hatfield.com</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    metaInfo: {
      title: "Contact us"
    },
    data: () => ({
      videoLoaded: false
    }),
    mounted: function () {
      this.$emit('header-color', true);
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .section {

    &.contact {
      height: 100vh;

      .background::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background: #fff;
        transform: scaleY(0);
      }

      .content {
        height: 50vh;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        padding-left: 4rem;
        padding-bottom: 4rem;
        flex-direction: column;
        box-sizing: border-box;

        .section-header {
          color: #000 !important;
          text-align: left !important;
        }

        .section-title {
          color: #000 !important;
          text-align: left !important;
        }

        .section-text {
          color: #000 !important;
          text-align: left !important;

          p {
            padding: 0;
            margin: 0;
          }

          .blue {
            position: relative;
            padding-bottom: 0.1em;
            color: $accent-color;
            text-decoration: none;
            display: inline-block;

            &::after {
              content: '';
              display: block;
              position: absolute;
              left: 50%;
              bottom: 0;
              width: 0;
              height: 2px;
              background: $accent-color;
              @include transition(width $default-ease 500ms, left $default-ease 500ms);
            }

            &:hover::after {
              left: 0;
              width: 100%;
            }
          }
        }
      }
    }

    @include media-query(medium) {

      &.contact {

        .content {
          padding-left: 1rem;
          padding-bottom: 1rem;

        }
      }
    }
  }

  .loaded {

    .contact {

      .background::after {
        transform-origin: center top;
        @include animation(heightStretch 500ms $default-ease 0s 1 forwards);
      }

      .title-header {
        @include animation(fadeIn 1s $default-ease 400s 1 forwards);
      }

      .title {
        @include animation(fadeIn 1s $default-ease 600ms 1 forwards);
      }

      .text {
        @include animation(fadeIn 1s $default-ease 800ms 1 forwards);
      }
    }
  }
</style>
